import Component from './Component';
import React from 'react';
import {OverlayTrigger, Tooltip, Popover} from 'react-bootstrap';


export default class Help extends Component {

	render() {
		return (
			<OverlayTrigger placement='top' overlay={<Popover id="help">{this.props.children}</Popover>}>
				<span className="fa fa-question-circle position-right"></span>
			</OverlayTrigger>
			)
	}
}


// WEBPACK FOOTER //
// ./src/components/Help.js